import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("../views/Frame.vue"),
    children: [
      {
        path: "",
        name: "Index",
        component: () => import("../views/IndexView.vue"),
        meta: {},
      },

      // {
      //   path: "dashboards",
      //   component: { template: "<router-view/>" },
      //   children: [
      //     {
      //       path: "president",
      //       name: "PresidentIndex",
      //       component: () => import("../views/dashboards/President.vue"),
      //       meta: {
      //         dutiesAllowed: ["President"],
      //       },
      //     },
      //   ],
      // },

      {
        path: "school-batches",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "SchoolBatchList",
            component: () =>
              import("../views/schoolBatches/SchoolBatchList.vue"),
            meta: {
              dutiesAllowed: ["President"],
            },
          },
          {
            path: "dashboards",
            name: "SchoolBatchDashboardList",
            component: () =>
              import("../views/schoolBatches/SchoolBatchList.vue"),
          },
          {
            path: "edit",
            name: "SchoolBatchEdit",
            component: () =>
              import("../views/schoolBatches/SchoolBatchEdit.vue"),
            meta: {
              dutiesAllowed: ["President"],
            },
          },
          // {
          //   path: "todo-list",
          //   name: "SchoolBatchTodoList",
          //   component: () => import("../views/schoolBatches/TodoList.vue"),
          //   meta: {
          //     dutiesAllowed: ["SportsTeacher"],
          //   },
          // },
          {
            path: "unsettled-list",
            name: "UnsettledSchoolBatchList",
            component: () => import("../views/schoolBatches/UnsettledList.vue"),
            meta: {
              dutiesAllowed: ["President"],
            },
          },
          {
            path: ":id",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "export",
                name: "SchoolBatchExport",
                component: () =>
                  import("../views/schoolBatches/SchoolBatchExport.vue"),
              },
            ],
          },
        ],
      },

      {
        path: "batches",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "BatchList",
            component: () => import("../views/batches/BatchList.vue"),
            meta: {
              dutiesAllowed: ["ClazzDirector", "SportsTeacher"],
            },
          },
          {
            path: "strict/:strict",
            name: "StrictBatchList",
            component: () => import("../views/batches/BatchList.vue"),
            meta: {
              dutiesAllowed: ["ClazzDirector", "SportsTeacher"],
            },
          },
          {
            path: "score-managenet/strict/:strict",
            name: "ScoreManagement",
            component: () => import("../views/batches/BatchList.vue"),
            meta: {
              dutiesAllowed: ["ClazzDirector", "SportsTeacher"],
            },
          },
          {
            path: "edit",
            name: "BatchEdit",
            component: () => import("../views/batches/BatchEdit.vue"),
            meta: {
              dutiesAllowed: ["ClazzDirector", "SportsTeacher"],
            },
          },
          {
            path: "todo-list",
            name: "BatchTodoList",
            component: () => import("../views/batches/TodoList.vue"),
            meta: {
              dutiesAllowed: ["SportsTeacher"],
            },
          },
          // {
          //   path: "create-new/school-batch/:schoolBatchId",
          //   name: "CreateNewBySchoolBatch",
          //   component: () =>
          //     import("../views/batches/CreateNewBySchoolBatch.vue"),
          //   meta: {
          //     dutiesAllowed: ["ClazzDirector", "SportsTeacher"],
          //   },
          // },
          {
            path: ":batchId",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "exam-records/edit",
                name: "ExamRecordBatchEdit",
                component: () =>
                  import("../views/examRecords/ExamRecordBatchEdit.vue"),
              },
              {
                path: "exam-records/import",
                name: "ExamRecordsImport",
                component: () =>
                  import("../views/examRecords/ExamRecordsImport.vue"),
              },
              {
                path: "vision-infos/edit",
                name: "VisionInfoBatchEdit",
                component: () =>
                  import("../views/visionInfos/VisionInfosBatchEdit.vue"),
              },
              {
                path: "vision-infos/import",
                name: "VisionInfoImport",
                component: () =>
                  import("../views/visionInfos/VisionInfosImport.vue"),
              },
              {
                path: "stat",
                name: "BatchStat",
                component: () => import("../views/stats/BatchStat.vue"),
              },
              {
                path: "fitness-reports",
                name: "BatchFitnessReports",
                component: () =>
                  import("../views/stats/BatchFitnessReports.vue"),
              },
              {
                path: "fail-details",
                name: "BatchFailDetail",
                component: () => import("../views/stats/BatchFailDetail.vue"),
              },
            ],
          },
        ],
      },

      // {
      //   path: "exam-records",
      //   component: { template: "<router-view/>" },
      //   children: [
      //     {
      //       path: "batch-edit/clazz/:clazzId",
      //       name: "ExamRecordBatchEdit",
      //       component: () =>
      //         import("../views/examRecords/ExamRecordBatchEdit.vue"),
      //     },
      //   ],
      // },

      {
        path: "bmi-track-records",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "BmiTrackRecordList",
            component: () =>
              import("../views/bmiTrackRecords/BmiTrackRecordList.vue"),
          },
          {
            path: "edit/:id",
            name: "BmiTrackRecordEdit",
            component: () =>
              import("../views/bmiTrackRecords/BmiTrackRecordEdit.vue"),
          },
        ],
      },

      {
        path: "stats",
        component: { template: "<router-view/>" },
        children: [
          /** 普通的成绩统计批次列表，可能已经没有用了 */
          {
            path: "batches/strict/:strict",
            name: "StatBatchList",
            component: () => import("../views/stats/BatchList.vue"),
          },

          /** 班级成绩分布查询的引导页，批次列表 */
          {
            path: "clazz-distributions/strict/:strict",
            name: "ClazzDistributionList",
            component: () => import("../views/stats/BatchList.vue"),
          },

          /** 班级成绩统计查询的引导页，批次列表 */
          {
            path: "clazz-batches/strict/:strict",
            name: "ClazzBatchList",
            component: () => import("../views/stats/BatchList.vue"),
          },
          {
            path: "school-distributions",
            name: "SchoolDistributionList",
            component: () =>
              import("../views/stats/distributions/SchoolList.vue"),
          },
          {
            path: "fail",
            name: "FailStatSchoolBatchList",
            component: () =>
              import("../views/stats/distributions/SchoolList.vue"),
          },
          {
            path: "grade-distributions",
            name: "GradeDistributionList",
            component: () =>
              import("../views/stats/distributions/GradeList.vue"),
          },
          // {
          //   path: "clazz-distributions",
          //   name: "ClazzDistributionList",
          //   component: () =>
          //     import("../views/stats/distributions/ClazzList.vue"),
          // },

          {
            path: "distribution-detail/batch/:batchId",
            name: "DistributionDetail",
            component: () =>
              import("../views/stats/distributions/DistributionDetail.vue"),
          },
          {
            path: ":schoolBatchId",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "distribution/school",
                name: "SchoolDistribution",
                component: () =>
                  import("../views/stats/distributions/DistributionStat.vue"),
              },
              {
                path: "distribution/grade/:gradeYear",
                name: "GradeDistribution",
                component: () =>
                  import("../views/stats/distributions/DistributionStat.vue"),
              },
              {
                path: "distribution/clazz/:clazzId",
                name: "ClazzDistribution",
                component: () =>
                  import("../views/stats/distributions/DistributionStat.vue"),
              },
              {
                path: "fail-details",
                name: "SchoolBatchFailDetail",
                component: () => import("../views/stats/BatchFailDetail.vue"),
              },

              /** 年级内各班优良率统计 */
              // {
              //   path: "good-rate/clazz/:clazzYear",
              //   name: "GoodRateStat",
              //   component: () => import("../views/stats/GoodRateStat.vue"),
              // },
            ],
          },

          /**
           * 学生历次历史成绩对比
           */
          {
            path: "history",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "choose-student",
                name: "HistoryStatChooseStudent",
                component: () =>
                  import("../views/stats/historyStats/ChooseStudent.vue"),
              },

              {
                path: "student-detail/:studentId",
                name: "HistoryStatStudentDetail",
                component: () =>
                  import("../views/stats/historyStats/StudentHistory.vue"),
              },
            ],
          },

          /**
           * 学生BMI变化趋势
           */
          {
            path: "bmi-trend/:studentId",
            name: "BmiTrendStat",
            component: () =>
              import("../views/bmiTrackRecords/StudentBmiTrend.vue"),
          },

          /** bmi重点人员检测的填报率统计批次列表 */
          {
            path: "bmi-track-rate-batches/strict/:strict",
            name: "BmiTrackRateBatchList",
            component: () =>
              import("../views/schoolBatches/SchoolBatchList.vue"),
          },

          /** bmi填报率统计页 */
          {
            path: "bmi-track-rate/:schoolBatchId",
            name: "StatBmiTrackRate",
            component: () =>
              import("../views/bmiTrackRecords/ReportingRate.vue"),
          },

          /** bmi异常人员查询列表页 */
          {
            path: "abnormal-bmi-batches/strict/:strict",
            name: "AbnormalBmiBatchList",
            component: () =>
              import("../views/schoolBatches/SchoolBatchList.vue"),
          },

          /** bmi异常人员查询结果 */
          {
            path: "abnormal-bmi/:schoolBatchId",
            name: "AbnormalBmiExamRecordList",
            component: () =>
              import("../views/bmiTrackRecords/AbnormalBmiExamRecordList.vue"),
          },
        ],
      },

      {
        path: "clazz-report-cards/grade-year/:gradeYear",
        name: "ClazzReportCardList",
        component: () =>
          import("../views/clazzReportCards/ClazzReportCardList.vue"),
      },

      {
        path: "grade-report-cards",
        name: "GradeReportCardList",
        component: () =>
          import("../views/gradeReportCards/GradeReportCardList.vue"),
      },

      {
        path: "courses",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "CourseList",
            component: () => import("../views/courses/CourseList.vue"),
          },
          {
            path: "edit",
            name: "CourseEdit",
            component: () => import("../views/courses/CourseEdit.vue"),
            meta: {
              rolesAllowed: ["ROLE_ADMIN"],
            },
          },
        ],
      },

      {
        path: "course-weights",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "CourseWeightList",
            component: () => import("../views/courses/CourseWeightList.vue"),
          },
          {
            path: "edit",
            name: "CourseWeightEdit",
            component: () => import("../views/courses/CourseWeightEdit.vue"),
          },
        ],
      },

      {
        path: "course/:courseId/course-weight-level-config",
        name: "CourseWeightLevelConfig",
        component: () => import("../views/courses/CourseWeightLevelConfig.vue"),
      },

      {
        path: "course/:courseId/course-weight-level-view",
        name: "CourseWeightLevelView",
        component: () => import("../views/courses/CourseWeightLevelView.vue"),
      },

      {
        path: "schools",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "SchoolList",
            component: () => import("../views/schools/SchoolList.vue"),
          },
          {
            path: "edit",
            name: "SchoolEdit",
            component: () => import("../views/schools/SchoolEdit.vue"),
          },
        ],
      },

      {
        path: "clazzes",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "ClazzList",
            component: () => import("../views/clazzes/ClazzList.vue"),
            meta: {
              dutiesAllowed: ["President", "GradeDirector"],
            },
          },
          {
            path: "edit",
            name: "ClazzEdit",
            component: () => import("../views/clazzes/ClazzEdit.vue"),
            meta: {
              dutiesAllowed: ["President"],
            },
          },
        ],
      },

      {
        path: "students",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "StudentList",
            component: () => import("../views/students/StudentList.vue"),
            meta: {},
          },
          {
            path: "edit",
            name: "StudentEdit",
            component: () => import("../views/students/StudentEdit.vue"),
            meta: {
              dutiesAllowed: ["President"],
            },
          },
          {
            path: "import",
            name: "StudentImport",
            component: () => import("../views/students/StudentImport.vue"),
            meta: {
              dutiesAllowed: ["President"],
            },
          },
          {
            path: "change-clazz/:id",
            name: "StudentChangeClazz",
            component: () => import("../views/students/StudentChangeClazz.vue"),
          },
          {
            path: ":id/batch/:batchId",
            component: { template: "<router-view/>" },
            children: [
              {
                path: "fitness-report",
                name: "FitnessReport",
                component: () => import("../views/students/FitnessReport.vue"),
              },
            ],
          },
        ],
      },

      {
        path: "duties",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "DutyList",
            component: () => import("../views/duties/DutyList.vue"),
          },
          {
            path: "edit",
            name: "DutyEdit",
            component: () => import("../views/duties/DutyEdit.vue"),
          },
          {
            path: "import",
            name: "DutyImport",
            component: () => import("../views/duties/DutyImport.vue"),
          },
        ],
      },

      {
        path: "users",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "",
            name: "UserList",
            component: () => import("../views/users/UserList.vue"),
          },
          {
            path: "edit",
            name: "UserEdit",
            component: () => import("../views/users/UserEdit.vue"),
          },
          {
            path: "profile",
            name: "Profile",
            component: () => import("../views/users/Profile.vue"),
          },
          {
            path: "change-password",
            name: "ChangePassword",
            component: () => import("../views/users/ChangePassword.vue"),
          },
          {
            path: "import",
            name: "UserImport",
            component: () => import("../views/users/UserImport.vue"),
          },
        ],
      },

      {
        path: "config",
        component: { template: "<router-view/>" },
        children: [
          {
            path: "student-columns",
            name: "StudentColumnsConfig",
            component: () => import("../views/config/StudentColumnConfig.vue"),
          },
          {
            path: "avg-score-offset",
            name: "AvgScoreOffsetConfig",
            component: () => import("../views/config/AvgScoreOffsetConfig.vue"),
          },
        ],
      },

      {
        path: "/choose-duty",
        name: "ChooseDuty",
        component: () => import("../views/duties/ChooseDuty.vue"),
      },

      {
        path: "/system-config",
        name: "SystemConfig",
        component: () => import("../views/config/SystemConfig.vue"),
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("../views/LoginView.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title;
  } else {
    store.dispatch("getProjectName").then(() => {
      document.title = store.state.projectName;
    });
  }

  //获取路由访问权限
  const rolesAllowed = to.meta.rolesAllowed;
  if (rolesAllowed) {
    if (Array.isArray(rolesAllowed)) {
      // 如果权限配置是数组
      const hasRole = rolesAllowed.some((role) =>
        store.getters.isUserInRole(role)
      );
      if (!hasRole) {
        next({
          name: "Login",
        });
        return;
      }
    } else if (typeof rolesAllowed === "string") {
      // 如果权限配置是字符串
      const hasRole = store.getters.isUserInRole(rolesAllowed);
      if (!hasRole) {
        next({
          name: "Login",
        });
        return;
      }
    }
  }

  const dutiesAllowed = to.meta.dutiesAllowed;
  if (dutiesAllowed) {
    if (Array.isArray(dutiesAllowed)) {
      // 如果权限配置是数组
      const authed = dutiesAllowed.some(
        (dutyType) => store.state.duty?.dutyType === dutyType
      );
      if (!authed) {
        next({
          name: "ChooseDuty",
        });
        return;
      }
    } else if (typeof dutiesAllowed === "string") {
      // 如果权限配置是字符串
      const authed = store.state.duty.dutyType === dutiesAllowed;
      if (!authed) {
        next({
          name: "ChooseDuty",
        });
        return;
      }
    }
  }

  if (to.name === "Login") {
    next();
  } else if (
    to.path.indexOf("/static") === 0 ||
    to.path.indexOf("/@/static") === 0
  ) {
    next();
  } else {
    next();
  }
});

export default router;
